<template>
  <div>
    <PlantillaLogin>
      <div slot="contenido">
        <b-loading :is-full-page="false" :active.sync="isLoading"></b-loading>

        <div
          class="columns is-centered"
          style="--eye-translate-x:0%; --eye-rotate:0deg; --eye-scale:1; --eye-fill:#00698f;"
        >
          <article class="column card is-full-mobile is-two-thirds-tablet is-half-desktop form">
            <form class="card-content" action v-on:submit.prevent="conectar">
              <h2 class="title has-text-primary">Servicio de Salud Magallanes</h2>
              <hr />

              <div class="field is-floating-label">
                <label for="username" class="label is-medium">RUT(SIN GUION y CON EL DIGITO VERIFICADOR Ej: 123456789)</label>
                <div class="control has-icons-left is-medium is-clearfix">
                  <input
                    autocomplete="on"
                    class="input is-medium data-hj-whitelist"
                    v-model="user.rut"
                    placeholder="RUT"
                    autofocus
                    required
                  />
                  <span class="icon is-left">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="user-shield"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 640 512"
                      class="svg-inline--fa fa-user-shield fa-w-20"
                    >
                      <path
                        fill="currentColor"
                        d="M622.3 271.1l-115.2-45c-4.1-1.6-12.6-3.7-22.2 0l-115.2 45c-10.7 4.2-17.7 14-17.7 24.9 0 111.6 68.7 188.8 132.9 213.9 9.6 3.7 18 1.6 22.2 0C558.4 489.9 640 420.5 640 296c0-10.9-7-20.7-17.7-24.9zM496 462.4V273.3l95.5 37.3c-5.6 87.1-60.9 135.4-95.5 151.8zM224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm96 40c0-2.5.8-4.8 1.1-7.2-2.5-.1-4.9-.8-7.5-.8h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c6.8 0 13.3-1.5 19.2-4-54-42.9-99.2-116.7-99.2-212z"
                        class
                      />
                    </svg>
                  </span>
                </div>
              </div>
              <div class="field is-floating-label">
                <label for="password" class="label is-medium">Contraseña</label>
                <div class="control has-icons-left has-icons-right is-medium is-clearfix">
                  <input
                    type="password"
                    autocomplete="on"
                    class="input is-medium"
                    v-model="user.password"
                    placeholder="Contraseña"
                    @enter="conectar"
                    required
                  />
                  <span class="icon is-left">
                    <svg
                      aria-hidden="true"
                      focusable="false"
                      data-prefix="fas"
                      data-icon="lock"
                      role="img"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                      class="svg-inline--fa fa-lock fa-w-14"
                    >
                      <path
                        fill="currentColor"
                        d="M400 224h-24v-72C376 68.2 307.8 0 224 0S72 68.2 72 152v72H48c-26.5 0-48 21.5-48 48v192c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48V272c0-26.5-21.5-48-48-48zm-104 0H152v-72c0-39.7 32.3-72 72-72s72 32.3 72 72v72z"
                        class
                      />
                    </svg>
                  </span>
                </div>
              </div>

              <div class="field">
                  <div class="columns">
                      <div class="column is-three-fifths">
                          <button type="submit" class="button is-medium is-primary is-fullwidth">
                              <span>Ingresar</span>
                              <span class="icon is-small">
                      <svg
                              aria-hidden="true"
                              focusable="false"
                              data-prefix="fas"
                              data-icon="sign-in-alt"
                              role="img"
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 512 512"
                              class="svg-inline--fa fa-sign-in-alt fa-w-16 fa-xs"
                      >
                        <path
                                fill="currentColor"
                                d="M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"
                                class
                        />
                      </svg>
                    </span>
                          </button>
                      </div>
                      <div class="column">
                          <button-show-registry></button-show-registry>
                      </div>
                  </div>
                  <b-message type="is-info" has-icon>
                    Si no puede acceder a la plataforma, favor de registrarse haciendo click en el botón y no olvidar ingresar con el rut sin el guión  Registrarse <b> <b-icon
                          icon="user-plus"
                          size="is-small">
                  </b-icon> Registrarse</b>
                  </b-message>
              </div>
            </form>
            <div class="field">
              <b-message type="is-danger" v-if="error">{{error}}</b-message>
              <!-- <label class="checkbox"></label> -->
            </div>
          </article>
          <article
            class="column card is-hidden-mobile is-on-thirds-tablet is-half-desktop back-img"
          >
            <img src="\images\covid.png" />
          </article>
        </div>
      </div>
    </PlantillaLogin>
  </div>
</template>
<script>
import PlantillaLogin from "../template/PlantillaLogin";
import ButtonShowRegistry from "@/components/registryUserOutLogin/ButtonShowRegistry.vue";
export default {
  name: "Login",
  components: {
    PlantillaLogin: PlantillaLogin,
      ButtonShowRegistry
  },
  data() {
    return {
      user: {
        rut: "",
        password: "",
        grant_type: "password",
        token: "",
        role_id: "",
      },
      error: "",
      isLoading: false,
    };
  },
  methods: {
    conectar: function () {
      this.error = "";
      this.isLoading = true;
      this.$http
        .post("api/auth", {
          rut: this.user.rut,
          password: this.user.password,
          grant_type: this.user.grant_type,
        })
        .then((response) => {
          console.log(response.body.user);
          this.user.token = response.body.token;
          window.localStorage.setItem(
            "token",
            (this.user.token = response.body.token)
          );
          window.localStorage.setItem(
            "userName",
            `${response.body.user.name} ${response.body.user.pather_lastname} ${response.body.user.mother_lastname}`
          );
          window.localStorage.setItem("perfil", response.body.user.role.type);
          window.localStorage.setItem(
            "user",
            JSON.stringify(response.data.user)
          );
          this.user.role_id = response.body.user.role_id;
          switch (this.user.role_id) {
            case 2:
              this.$router.push({ name: "administrativeHome" });
              this.isLoading = false;
              break;
            case 3:
              this.$router.push({ name: "questionary" });
              this.isLoading = false;
              break;            
          }
          // if (this.user.role_id === 1) {
          //   this.$router.push(
          //     {
          //       name: "login",
          //     },
          //     () => {}
          //   );
          //   this.isLoading = false;
          // } else if (this.user.role_id === 2 ||this.user.role_id === 5 || this.user.role_id === 3 || this.user.role_id === 4) {
          //   this.$router.push({ name: "administrative"});
          //   this.isLoading = false;
          // }
        })
        .catch((response) => {
          this.isLoading = false;
          this.error = "Usuario y/o contraseña incorrecta";
          console.error(response);
        });
    },
  },
};
</script>